module.exports = __webpack_public_path__ + "static/img/base_one.9366df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/base_one.png
// module id = NcEt
// module chunks = 1